export default "/images/ac9165910390b79f125662eb6f2f1226.avif";